export default {
  title: {
    id: 'insights_portal_hub_title',
    defaultMessage: 'Welcome to your analytics hub!',
  },
  subtitle: {
    id: 'insights_portal_hub_subtitle',
    defaultMessage:
      'Check out all the data related to your shop’s activities and performance on Back Market. Let’s get down to business!',
  },
  goToReportButtonLabel: {
    id: 'insights_portal_go_to_report_button_label',
    defaultMessage: 'Go to {name}',
  },
}
